<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
      <path d="M1463 2855 c-41 -17 -73 -69 -73 -116 0 -46 35 -95 123 -172 37 -32 67 -63 67 -68 0 -5 -103 -9 -244 -9 l-244 0 -31 -25 c-54 -46 -63 -122 -21 -173 38 -46 73 -52 317 -52 l228 0 -94 -94 c-90 -90 -94 -96 -99 -145 -4 -49 -3 -52 37 -92 40 -40 43 -41 92 -37 l52 5 218 220 219 219 0 54 0 54 -207 209 c-239 240 -263 256 -340 222z"/>
      <path d="M230 2539 c-54 -12 -90 -59 -90 -118 0 -63 24 -94 104 -130 234 -106 416 -317 486 -563 31 -106 38 -289 16 -398 -36 -176 -115 -326 -238 -449 -75 -75 -143 -123 -255 -180 -91 -45 -113 -72 -113 -140 0 -71 77 -132 146 -115 51 12 207 97 284 155 374 282 530 776 389 1234 -28 92 -97 230 -156 313 -101 143 -281 292 -434 361 -81 36 -96 39 -139 30z"/>
      <path d="M2724 2535 c-107 -32 -269 -138 -380 -249 -168 -169 -277 -381 -315 -616 -15 -96 -12 -293 6 -388 54 -281 231 -553 463 -711 72 -49 210 -119 249 -127 68 -13 143 52 143 124 0 52 -28 90 -90 119 -216 104 -352 234 -445 427 -60 124 -85 232 -85 374 0 189 42 336 139 485 88 133 203 233 368 316 88 44 113 73 113 131 0 87 -78 141 -166 115z"/>
      <path d="M1455 1101 c-50 -31 -423 -414 -435 -445 -22 -60 -9 -80 209 -299 113 -115 218 -215 233 -223 87 -45 191 36 173 135 -5 27 -29 58 -98 128 l-91 93 215 0 c244 1 283 6 322 50 22 25 27 40 27 81 0 45 -4 55 -34 85 l-34 34 -246 0 c-135 0 -246 3 -246 8 0 4 36 43 81 87 114 113 131 154 89 222 -36 60 -109 79 -165 44z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconInternalTransfer",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
